import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessageQuestionOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23 17V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h2v6a1 1 0 0 0 .61.92A1.1 1.1 0 0 0 8 27a1 1 0 0 0 .7-.29L15.41 20H20a3 3 0 0 0 3-3m-8.71 1.29L9 23.59V20a2 2 0 0 0-2-2H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 0-.71.29" />
    <path d="M15.15 9.08c0-1.26-1.07-2.14-2.67-2.14A2.54 2.54 0 0 0 9.9 8.5a1.6 1.6 0 0 0-.05.38.62.62 0 0 0 .7.67.69.69 0 0 0 .72-.47 1.09 1.09 0 0 1 1.11-.83.94.94 0 0 1 1.06.88c0 .51-.22.78-.94 1.2a1.69 1.69 0 0 0-1 1.57v.1a.67.67 0 0 0 .76.67.67.67 0 0 0 .75-.57c0-.47.26-.71 1-1.12a2 2 0 0 0 1.14-1.9m-2.88 4.23a.89.89 0 1 0 .92.88.89.89 0 0 0-.92-.88m10.83 9.12a.6.6 0 0 1 0-.12.6.6 0 0 0 0 .12" />
    <path d="M27 5h-1a1 1 0 0 0 0 2h1a1 1 0 0 1 1 1v11.57A1.43 1.43 0 0 1 26.57 21H25a1.8 1.8 0 0 0-.4 0l-.17.05-.2.06-.24.13h-.09a2 2 0 0 0-.28.23 2 2 0 0 0-.24.29 2.4 2.4 0 0 0-.22.45.6.6 0 0 0 0 .12A1.8 1.8 0 0 0 23 23v3.59l-.73-.72-3.5-3.5a1 1 0 0 0-1.41 1.42l5.93 5.94a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .54-.54A1 1 0 0 0 25 29v-6h2a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3" />
  </svg>
);
const ForwardRef = forwardRef(IconMessageQuestionOutlineSVG);
ForwardRef.displayName = "IconMessageQuestionOutline";
export { ForwardRef as IconMessageQuestionOutline };
